import React, { Component } from 'react';
import axios from 'axios';
import Moment from 'react-moment';

// Components

export class Event extends Component  {
  state = {
    isLoaded: false, videos: [], aseVideos: [], asVideos: [], ciVideos: [], hlVideos: [], olVideos: [], ssVideos: []
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('#main').classList.remove('hero');

    const googleAPI = process.env.REACT_APP_GOOGLEAPI;
    const googleAPI_Key = process.env.REACT_APP_GOOGLEAPIKEY,
          param_part = 'snippet,id',
          param_maxResults = (this.props.count) ? this.props.count : 50;

    const videos_ASE = axios.get(googleAPI+'/playlistItems', {
      params: {
        part: param_part,
        maxResults: param_maxResults,
        key: googleAPI_Key,
        playlistId: 'PLx9J53NyYBSNIGjFnPt7KJdt90KUMpUtB'
      }
    });
    const videos_AS = axios.get(googleAPI+'/playlistItems', {
      params: {
        part: param_part,
        maxResults: param_maxResults,
        key: googleAPI_Key,
        playlistId: 'PLx9J53NyYBSPOsAocJ36KRC_FlbkNh_k3'
      }
    });
    const videos_CI = axios.get(googleAPI+'/playlistItems', {
      params: {
        part: param_part,
        maxResults: param_maxResults,
        key: googleAPI_Key,
        playlistId: 'PLx9J53NyYBSMTEwaC6ZMos5sjQs2ozM_g'
      }
    });
    const videos_HL = axios.get(googleAPI+'/playlistItems', {
      params: {
        part: param_part,
        maxResults: param_maxResults,
        key: googleAPI_Key,
        playlistId: 'PLx9J53NyYBSPblMcUVy2Qza84c_ga4Ysy'
      }
    });
    const videos_OL = axios.get(googleAPI+'/playlistItems', {
      params: {
        part: param_part,
        maxResults: param_maxResults,
        key: googleAPI_Key,
        playlistId: 'PLx9J53NyYBSPdtWhs0B7dvwuL9UAeeG3L'
      }
    });
    const videos_SS = axios.get(googleAPI+'/playlistItems', {
      params: {
        part: param_part,
        maxResults: param_maxResults,
        key: googleAPI_Key,
        playlistId: 'PLx9J53NyYBSP40b3vqX0mLaFPtx0zFw0a'
      }
    });

    axios.all([videos_ASE, videos_AS, videos_CI, videos_HL, videos_OL, videos_SS])
    .then(res => {

      let ase = res[0].data.items.filter((obj) => typeof obj.snippet.thumbnails.medium != typeof undefined)
      let as = res[1].data.items.filter((obj) => typeof obj.snippet.thumbnails.medium != typeof undefined)
      let ci = res[2].data.items.filter((obj) => typeof obj.snippet.thumbnails.medium != typeof undefined)
      let hl = res[3].data.items.filter((obj) => typeof obj.snippet.thumbnails.medium != typeof undefined)
      let ol = res[4].data.items.filter((obj) => typeof obj.snippet.thumbnails.medium != typeof undefined)
      let ss = res[5].data.items.filter((obj) => typeof obj.snippet.thumbnails.medium != typeof undefined)

      this.setState({
        aseVideos: ase,
        asVideos: as,
        ciVideos: ci,
        hlVideos: hl,
        olVideos: ol,
        ssVideos: ss,
        isLoaded: true
      })
    });

    // axios.get(googleAPI+'/playlistItems', {
    //   params: {
    //     part: 'snippet,id',
    //     maxResults: (this.props.count) ? this.props.count : 50,
    //     // maxResults: 50,
    //     key: googleAPI_Key,
    //     playlistId: 'PLx9J53NyYBSNiocDLwQM3obxJaG1LOUUS'
    //     // playlistId: 'PLzBbnBKcseMu-NJdijrdUo1-5redSlwck'
    //   }
    // })
    // .then(res => {
    //   this.setState({ videos: res.data.items, isLoaded: true })
    //   // console.dir(res);
    // });
  }

  render() {
    const { isLoaded, aseVideos, asVideos, ciVideos, hlVideos, olVideos, ssVideos } = this.state;

    return (
      <>
        <div className="pageContent">
          <div className="container">
            <div className="row">

              {isLoaded && (
                <>
                  <div className="col-12 contentCont">
                    <h1>USAHS iLEARN Videos</h1>

                    {aseVideos.length > 0 && (
                      <>
                        <h2>Academic Skills Enrichment</h2>
                        <div className="videoGrid">
                          {aseVideos.reverse().map((v, index) =>
                            <div className="video" key={ index }>
                              <a href={ '/video?videoid=' + v.snippet.resourceId.videoId }>
                                <img src={ v.snippet.thumbnails.medium.url } alt={ v.snippet.title } />
                                <div className="vidInfo">
                                  <p className="title"><Moment date={ v.snippet.publishedAt } format='MMMM DD, YYYY' /> { v.snippet.title }</p>
                                  <p className="playVideo"><i className="fab fa-youtube"></i></p>
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {asVideos.length > 0 && (
                      <>
                        <h2>Academic Success</h2>
                        <div className="videoGrid">
                          {asVideos.reverse().map((v, index) =>
                            <div className="video" key={ index }>
                              <a href={ '/video?videoid=' + v.snippet.resourceId.videoId }>
                                <img src={ v.snippet.thumbnails.medium.url } alt={ v.snippet.title } />
                                <div className="vidInfo">
                                  <p className="title"><Moment date={ v.snippet.publishedAt } format='MMMM DD, YYYY' /> { v.snippet.title }</p>
                                  <p className="playVideo"><i className="fab fa-youtube"></i></p>
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {ciVideos.length > 0 && (
                      <>
                        <h2>Clinical Innovation</h2>
                        <div className="videoGrid">
                          {ciVideos.reverse().map((v, index) =>
                            <div className="video" key={ index }>
                              <a href={ '/video?videoid=' + v.snippet.resourceId.videoId }>
                                <img src={ v.snippet.thumbnails.medium.url } alt={ v.snippet.title } />
                                <div className="vidInfo">
                                  <p className="title"><Moment date={ v.snippet.publishedAt } format='MMMM DD, YYYY' /> { v.snippet.title }</p>
                                  <p className="playVideo"><i className="fab fa-youtube"></i></p>
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {hlVideos.length > 0 && (
                      <>
                        <h2>Healthcare Leadership</h2>
                        <div className="videoGrid">
                          {hlVideos.reverse().map((v, index) =>
                            <div className="video" key={ index }>
                              <a href={ '/video?videoid=' + v.snippet.resourceId.videoId }>
                                <img src={ v.snippet.thumbnails.medium.url } alt={ v.snippet.title } />
                                <div className="vidInfo">
                                  <p className="title"><Moment date={ v.snippet.publishedAt } format='MMMM DD, YYYY' /> { v.snippet.title }</p>
                                  <p className="playVideo"><i className="fab fa-youtube"></i></p>
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {olVideos.length > 0 && (
                      <>
                        <h2>Online Learning</h2>
                        <div className="videoGrid">
                          {olVideos.reverse().map((v, index) =>
                            <div className="video" key={ index }>
                              <a href={ '/video?videoid=' + v.snippet.resourceId.videoId }>
                                <img src={ v.snippet.thumbnails.medium.url } alt={ v.snippet.title } />
                                <div className="vidInfo">
                                  <p className="title"><Moment date={ v.snippet.publishedAt } format='MMMM DD, YYYY' /> { v.snippet.title }</p>
                                  <p className="playVideo"><i className="fab fa-youtube"></i></p>
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {ssVideos.length > 0 && (
                      <>
                        <h2>Scholarly Skills</h2>
                        <div className="videoGrid">
                          {ssVideos.reverse().map((v, index) =>
                            <div className="video" key={ index }>
                              <a href={ '/video?videoid=' + v.snippet.resourceId.videoId }>
                                <img src={ v.snippet.thumbnails.medium.url } alt={ v.snippet.title } />
                                <div className="vidInfo">
                                  <p className="title"><Moment date={ v.snippet.publishedAt } format='MMMM DD, YYYY' /> { v.snippet.title }</p>
                                  <p className="playVideo"><i className="fab fa-youtube"></i></p>
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                  </div>
                </>
              )}

            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Event;